import { render, staticRenderFns } from "./FzrXm1.vue?vue&type=template&id=2e40963d&scoped=true"
import script from "./FzrXm1.vue?vue&type=script&lang=js"
export * from "./FzrXm1.vue?vue&type=script&lang=js"
import style0 from "./FzrXm1.vue?vue&type=style&index=0&id=2e40963d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e40963d",
  null
  
)

export default component.exports